import { ObservableCollection } from './../../observable';

export class DefaultValueProvider {
    public static getDefaultValueOf(type: Object): any {
        if (type === Boolean) return DefaultValueProvider.boolean();
        if (type === Number) return DefaultValueProvider.number();
        if (type === String) return DefaultValueProvider.string();
        if (type === Date) return DefaultValueProvider.date();
        if (type === Array) return [];
        if (type === ObservableCollection) return new ObservableCollection();
        if (typeof type === 'function') return DefaultValueProvider.object();
    }

    public static boolean(): boolean { return false; }

    public static number(): number { return 0; }

    public static string(): string | null { return null; }

    public static date(): Date { return new Date(1, 1, 1, 0, 0, 0, 0); }

    public static object(): unknown { return null; }
}
